/* eslint-disable import/extensions */
import { Marked } from 'marked';

const mMarked = new Marked();

const renderer = new mMarked.Renderer();
renderer.paragraph = (text) => {
  let newText = text;

  const regexB = /\*\*(.*?)\*\*/g;
  newText = newText.replace(regexB, '<strong>$1</strong>');

  const regexI = /_(.*?)_/g;
  newText = newText.replace(regexI, '<em>$1</em>');

  const regexU = /\+\+(.*?)\+\+/g;
  newText = newText.replace(regexU, '<ins>$1</ins>');

  const regexS = /~~(.*?)~~/g;
  newText = newText.replace(regexS, '<del>$1</del>');

  return newText;
};
renderer.link = (href, title, text) => text;

mMarked.use({
  breaks: true,
  gfm: true,
  sanitize: true,
  smartypants: true,
  renderer,
});

export default mMarked;



// WEBPACK FOOTER //
// ./src/utils/marked.js